<template>
    <!--srccomponentscardIconindexvuehtmlStart-->

    <div id="defaultId1" class="      uObrsVt">
        <div id="g7dc27" class="          ua48dd">
            <div id="g4fce3" @click="changValue('table')"
                :style="activeIcon == 'table' ? 'background-color:#fff;' : 'background-color:#F5F5F5'"
                class="          u6b0ab">
                <svg id="idDG8I5J" class="icon        " t="1718789106236" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="4653" width="2.35em" height="2.35em">
                    <path id="idZjnsA6"
                        d="M928 938.666667H96a53.393333 53.393333 0 0 1-53.333333-53.333334V181.333333a53.393333 53.393333 0 0 1 53.333333-53.333333h832a53.393333 53.393333 0 0 1 53.333333 53.333333v704a53.393333 53.393333 0 0 1-53.333333 53.333334z m-245.333333-42.666667h245.333333a10.666667 10.666667 0 0 0 10.666667-10.666667v-202.666666h-256z m-298.666667 0h256v-213.333333H384z m-298.666667-213.333333v202.666666a10.666667 10.666667 0 0 0 10.666667 10.666667h245.333333v-213.333333z m597.333334-42.666667h256V426.666667h-256z m-298.666667 0h256V426.666667H384z m-298.666667 0h256V426.666667H85.333333z m853.333334-256V181.333333a10.666667 10.666667 0 0 0-10.666667-10.666666H96a10.666667 10.666667 0 0 0-10.666667 10.666666v202.666667z"
                        :fill="activeIcon == 'table' ? '#1290C9' : '#8497AB'" p-id="4654">
                    </path>
                </svg>
            </div>
            <div id="g8d8d0" @click="changValue('computer')"
                :style="activeIcon == 'computer' ? 'background-color:#fff;' : 'background-color:#F5F5F5'"
                class="          u3c550">
                <svg id="iddLfMVi" class="icon         " t="1718788779202" viewBox="0 0 1214 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="4457" width="2.57em" height="2.57em">
                    <path id="id5okIFH"
                        d="M94.734629 819.2c-52.0192 0-94.354286-40.872229-94.354286-91.077486V341.284571c0-13.312 11.190857-24.107886 24.9856-24.107885 13.780114 0 22.908343 10.795886 22.908343 24.107885v386.823315c0 23.639771 21.986743 44.675657 46.460343 44.675657h1018.953142c24.488229 0 47.030857-21.035886 47.030858-44.675657V93.037714c0-23.6544-22.528-43.695543-47.030858-43.695543H94.734629C70.261029 49.3568 48.274286 69.397943 48.274286 93.037714v107.373715c0 13.297371-9.128229 24.093257-22.908343 24.093257-13.794743 0-25.000229-10.795886-25.000229-24.107886V93.037714C0.365714 42.832457 42.715429 1.989486 94.734629 1.989486h1018.953142c52.0192 0 94.339657 40.842971 94.339658 91.077485v635.070172c0 50.205257-42.320457 91.077486-94.339658 91.077486H94.734629z"
                        :fill="activeIcon == 'computer' ? '#1290C9' : '#8497AB'" p-id="4458">
                    </path>
                    <path id="idN3M6gw"
                        d="M704.2048 965.485714H855.771429c12.112457 0 21.694171 11.264 21.694171 23.376457 0 12.112457-9.581714 23.6544-21.694171 23.6544h-482.742858c-12.112457 0-22.191543-11.541943-22.191542-23.6544 0-12.127086 10.079086-23.376457 22.191542-23.376457h151.581258V819.2H570.514286v146.285714h87.771428V819.2h45.919086v146.285714zM177.678629 620.163657h44.426971V461.531429h-44.426971zM296.1408 620.163657h44.412343V389.412571h-44.412343zM429.407086 620.163657h44.412343V317.293714h-44.412343zM236.909714 187.4944c0 15.915886-13.268114 28.847543-29.608228 28.847543-16.384 0-29.622857-12.931657-29.622857-28.847543 0-15.945143 13.253486-28.847543 29.622857-28.847543 16.340114 0 29.608229 12.9024 29.608228 28.847543M325.749029 187.4944c0 15.915886-13.268114 28.847543-29.608229 28.847543s-29.608229-12.931657-29.608229-28.847543c0-15.945143 13.268114-28.847543 29.608229-28.847543s29.608229 12.9024 29.608229 28.847543M714.591086 420.322743h148.728685l112.347429-93.432686c-26.814171-30.939429-68.183771-52.077714-112.347429-52.077714-79.491657 0-146.666057 66.530743-148.728685 145.5104zM820.662857 568.188343l21.869714-113.2544h-126.098285c16.310857 53.642971 51.053714 91.399314 104.228571 113.2544z m174.474972-210.549029l-91.428572 77.297372 91.428572 54.535314C1004.251429 470.381714 1009.371429 446.800457 1009.371429 424.228571c0-23.2448-4.593371-47.074743-14.2336-66.589257zM877.714286 462.760229l-20.289829 110.270171c1.594514 0.043886 3.189029 0.073143 4.783543 0.073143 44.909714 0 87.815314-20.904229 114.644114-52.736L877.714286 462.760229zM863.085714 614.4c-105.033143 0-190.171429-85.138286-190.171428-190.171429s85.138286-190.171429 190.171428-190.171428 190.171429 85.138286 190.171429 190.171428-85.138286 190.171429-190.171429 190.171429z"
                        :fill="activeIcon == 'computer' ? '#1290C9' : '#8497AB'" p-id="4459">
                    </path>
                </svg>
            </div>
        </div>
        <!-- <div id="g321f1" @click="changeMap" class="     ubnpxIG" v-if="isShowMapIcon">
            <svg id="idIVzTtU" class="icon     " t="1718850129425" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4457" width="1.32em" height="1.32em">
                <path id="idoIJnIg"
                    d="M916.3 604.86c9.93-35.71 14.95-72.65 14.95-110.35 0-55.54-10.88-109.44-32.35-160.18-20.73-49-50.39-93.01-88.18-130.79s-81.79-67.45-130.79-88.18C629.19 93.9 575.3 83.02 519.75 83.02c-55.54 0-109.44 10.88-160.18 32.35-49 20.73-93.01 50.39-130.79 88.18s-67.45 81.79-88.18 130.79c-21.46 50.74-32.35 104.64-32.35 160.18s10.88 109.44 32.35 160.18c20.73 49 50.39 93.01 88.18 130.79s81.79 67.45 130.79 88.18c50.74 21.46 104.64 32.35 160.18 32.35 28.87 0 57.28-2.95 85.05-8.78 1.87-0.13 3.73-0.53 5.52-1.2 23.74-5.34 46.99-12.8 69.62-22.36 49-20.73 93.01-50.39 130.79-88.18s67.45-81.79 88.18-130.79c6.85-16.2 12.62-32.73 17.31-49.53 0.02-0.11 0.05-0.21 0.08-0.32z m-24.05-110.34c0 29.91-3.53 59.28-10.34 87.65l-0.48-0.33c-4.76-3.32-10.69-7.46-18.64-9.55-11.61-3.05-21.88-0.39-30.13 1.76-2.92 0.76-5.67 1.47-7.91 1.77-5.32 0.7-11.41-1.51-16.31-5.92-4.89-4.41-7.72-10.25-7.57-15.61 0.09-3.14 0.9-7.01 1.75-11.11 1.67-7.97 3.74-17.89 1.72-28.71-5.3-28.48-34.59-43.53-59.44-43.18-18.81 0.24-35.67 7.16-50.54 13.26-2.23 0.91-4.45 1.83-6.67 2.71a332.646 332.646 0 0 1-43.36 13.93c-8.88 2.19-18.19 4.06-26.05 2.86-8.06-1.22-16.82-5.98-25.29-10.58-9.75-5.29-19.84-10.77-26.86-17.78-5.93-5.92-9.22-12.84-8.8-18.53 0.66-8.89 10.39-17.01 19.74-21.1 8.4-3.68 18.05-5.78 28.26-8.01 6.08-1.33 12.38-2.7 18.73-4.48 25.85-7.23 43.79-19.87 53.32-37.57 11.26-20.91 8.04-42.87 5.19-62.24-1.61-10.98-3.14-21.36-1.93-30.29 1.88-13.94 13.04-32.99 38.73-44.63 20.5-9.29 44.21-11.86 67.48-13.89 68 69.88 105.4 161.84 105.4 259.57zM365.8 165.1c20.89 3.26 40.01 14.61 51.15 30.34 11.42 16.12 14.56 37.57 8 54.64-2.41 6.26-5.34 8.74-6.12 8.93-0.69 0.1-2.94-0.76-4.53-2.66-2.03-2.44-3.53-6.26-4.34-11.06-2.17-12.92-14.04-21.89-27.02-20.42-8.99 1.02-17.76 2.58-26.24 4.08-14.24 2.53-27.69 4.92-40.72 4.59-16.1-0.41-34.47-7.35-40.87-19.93 24.6-21.49 51.59-39.43 80.33-53.58 2.77 2.6 6.32 4.44 10.36 5.07zM256.36 757.91c-27.42-27.42-50.02-58.38-67.42-91.83 0.28-0.73 0.54-1.48 0.73-2.26 6.93-27.38 20.76-52.8 39.98-73.5 21.91-23.6 58.91-46.28 97-39.14 11.24 2.11 20.07 6.67 24.84 12.84 6.67 8.62 7.52 21.79 8.52 37.03 0.58 8.97 1.19 18.24 3.08 27.62 3.97 19.61 13.34 38.69 29.51 60.05 10.16 13.43 24.53 29.66 45.63 36.08 32.06 9.76 62.85-7.69 83.22-21.66 2.91-2 8.94-6.13 11.05-6.22 0.6 0.23 2.41 1.51 3.91 4.23 3.98 7.18 2.82 17.61-2.64 23.75-0.47 0.53-0.97 1.08-1.47 1.64-3.39 3.74-7.61 8.4-10.61 14.06-5.49 10.34-5.23 21.41 0.73 30.38 3.95 5.94 9.26 9.1 13.45 11.2 20.19 10.08 44.17 12.16 65.79 5.7 1.17-0.35 2.33-0.72 3.49-1.1 2.06-0.67 4.62-1.49 5.63-1.52 0.41 0.02 2.27 0.42 4.79 2.56 8.52 7.21 11.44 22.27 6.94 35.81-4.02 12.11-12.98 23.85-27.32 35.78-24.56 5.03-49.8 7.62-75.45 7.62-99.49-0.01-193.03-38.76-263.38-109.12z m526.79 0c-36.38 36.38-78.97 64.28-125.37 82.77 0.63-1.58 1.22-3.18 1.76-4.78 9.6-28.94 2.06-60.23-18.76-77.86-9.35-7.91-20.4-12.1-31.16-11.77-6.56 0.2-12.05 1.97-16.46 3.4-0.89 0.29-1.77 0.57-2.66 0.84-8.96 2.67-18.62 2.76-27.64 0.38 0.02-0.02 0.04-0.05 0.06-0.07 16.53-18.59 19.67-46.78 7.62-68.55-7.82-14.13-20.94-23.2-35.09-24.24-15.49-1.13-27.38 7-36.06 12.95-21.82 14.97-37.65 20.21-49.81 16.51-10.37-3.15-19.28-13.58-25.89-22.31-12.5-16.52-19.61-30.57-22.38-44.24-1.38-6.8-1.87-14.39-2.39-22.43-1.23-18.89-2.62-40.31-16.58-58.36-10.79-13.95-27.56-23.39-48.51-27.32-23.6-4.42-49-1.33-73.46 8.94-21.79 9.16-42.3 23.68-59.31 42-13.86 14.93-25.42 31.86-34.35 50.1-12.79-37.95-19.46-78.14-19.46-119.37 0-94.8 35.2-184.18 99.37-253.26 5.82 7.56 13.46 14.06 22.73 19.21 13.25 7.37 29.47 11.65 45.65 12.06 16.97 0.43 33.01-2.42 48.52-5.18 3.96-0.7 7.81-1.39 11.61-2.01 2.29 6.02 5.38 11.38 9.24 16 8.88 10.63 21.69 16.66 34.42 16.66 3.12 0 6.23-0.36 9.28-1.11 14.71-3.59 26.53-15.25 33.29-32.83 11.28-29.35 6.46-64.29-12.58-91.17-10.11-14.27-23.85-25.95-39.78-34.2 35.4-10.97 72.64-16.68 110.75-16.68 83.81 0 163.4 27.5 228.46 78.22-15.06 2.53-30.31 6.42-44.93 13.05-33.62 15.24-57.1 43.96-61.28 74.95-1.94 14.37 0.15 28.61 2 41.17 2.25 15.32 4.19 28.54-0.94 38.07-5.38 9.98-19.01 15.58-29.5 18.51-5.26 1.47-10.74 2.67-16.53 3.93-11.63 2.54-23.65 5.16-35.6 10.39-24.86 10.89-41.33 31.56-42.99 53.95-1.27 17.12 6.07 34.99 20.14 49.03 11.01 10.99 24.18 18.14 35.8 24.44 10.89 5.91 23.23 12.61 38.05 14.86 14.61 2.22 28.46-0.4 41.25-3.56 16.43-4.06 32.74-9.29 48.46-15.56 2.34-0.93 4.68-1.89 7.02-2.85 12.79-5.25 24.87-10.2 36.25-10.35 9.65-0.11 19.47 5.27 20.6 11.32 0.6 3.25-0.45 8.28-1.56 13.6-1.11 5.33-2.37 11.36-2.56 17.97-0.48 16.89 6.96 33.54 20.43 45.69 13.47 12.15 30.79 17.84 47.54 15.63 4.61-0.61 8.85-1.71 12.6-2.68 3.86-1 8.67-2.25 10.42-1.79 1.23 0.32 4 2.26 6.23 3.81 2.55 1.78 5.43 3.79 8.81 5.62 0.83 0.45 1.67 0.86 2.51 1.25-18.3 51.03-47.82 97.79-87.28 137.25z"
                    p-id="4458" :fill="value ? '#1290C9' : '#8497AB'">
                </path>
            </svg>
        </div> -->
    </div>
    <!--srccomponentscardIconindexvuehtmlEnd-->

</template>
<script>
import {

    getPartPrivilege,
} from "@/api/companyApi";

export default {
    name: "",

    props: {
        // srccomponentscardIconindexvuePropsStart

        // srccomponentscardIconindexvuePropsEnd

        isShowMapIcon: {
            type: Boolean,
            default: true
        },

        value: {
            type: Boolean,
            default: true
        }
    },

    mounted() {
        this.getPartPrivilege()
        // defaultLoad
        // srccomponentscardIconindexvueMountedStart

        // srccomponentscardIconindexvueMountedEnd

    },
    components: {},
    data() {
        return {
            powerArr: [],
            // insertData
            // srccomponentscardIconindexvueDataStart

            // activeIcon
            activeIcon: 'table'
            // srccomponentscardIconindexvueDataEnd

        }
    },
    methods: {
        getPartPrivilege() {
            getPartPrivilege({
                moduleId: this.$route.query.idpower,
            }).then((res) => {
                this.powerArr[0] = res.data.filter((item) => item.id == "409")[0];
                this.powerArr[1] = res.data.filter((item) => item.id == "410")[0];
            });
        },
        default() {

        }, // changValue
        changValue(value) {

            if (value == "computer") {

                if (this.powerArr[0]?.hasPrivilege) {
                    this.activeIcon = value
                    this.$emit("change-value", this.activeIcon);
                }
                else {
                    this.activeIcon = 'table'
                    this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
                }
            } else {
                this.activeIcon = value
                this.$emit("change-value", this.activeIcon);
            }
            // this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");




        }, // changeMap
        changeMap() {
            if (this.powerArr[1]?.hasPrivilege) {

                this.value = !this.value;
                this.$emit("show-map", this.value);
            } else {
                this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
            }

        }
        // srccomponentscardIconindexvueMethodEnd

    },
    computed: {}
};
</script>
<style>
.srccomponentscardIconindexvuecssStart {}

.uObrsVt {
    display: flex;
}

.ua48dd {
    display: flex;
    width: 10em;
    height: 3.57em;
    background: #F5F5F5;
    border-radius: 1.78em;
    padding: 0.21em;
}

.u6b0ab {
    display: flex;
    justify-content: center;
    width: 50%;
    border-radius: 1.78em;
    align-items: center;
}

.u3c550 {
    display: flex;
    justify-content: center;
    width: 50%;
    border-radius: 1.78em;
    align-items: center;
}

.ubnpxIG {
    display: flex;
    justify-content: center;
    width: 4.71em;
    height: 3.14em;
    background: #FFFFFF;
    box-shadow: 0px 0.14em 0.28em 0px rgba(0, 0, 0, 0.1);
    border-radius: 1.57em;
    margin-left: 1.35em;
    align-items: center;
}

.srccomponentscardIconindexvuecssEnd {}
</style>